import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Button,
  Modal,
  Box,
  Typography,
  Card,
  ButtonGroup,
} from "@mui/material";

const roadArkings = {
  double_yellow_line: {
    cost_code: "1030",
    cost_type: "59978",
    account: "59978.1030",
    units_of_measure: "LF",
    description: "DOUBLE YELLOW LINE",
  },
  lanes_lines_4: {
    cost_code: "1031",
    cost_type: "59978",
    account: "59978.1031",
    units_of_measure: "EA",
    description: 'LANE LINES 4"',
  },
  four_lines: {
    cost_code: "1040",
    cost_type: "59978",
    account: "59978.1040",
    units_of_measure: "LF",
    description: '4" LINES',
  },
  six_lines: {
    cost_code: "1050",
    cost_type: "59978",
    account: "59978.1050",
    units_of_measure: "LF",
    description: '6" LINES',
  },
  eight_lines: {
    cost_code: "1060",
    cost_type: "59978",
    account: "59978.1060",
    units_of_measure: "LF",
    description: '8" LINES',
  },
  twelve_lines: {
    cost_code: "1070",
    cost_type: "59978",
    account: "59978.1070",
    units_of_measure: "LF",
    description: '12" LINES',
  },
  sixteen_lines: {
    cost_code: "1071",
    cost_type: "59978",
    account: "59978.1071",
    units_of_measure: "LF",
    description: '16" LINES',
  },
  twenty_four_lines: {
    cost_code: "1080",
    cost_type: "59978",
    account: "59978.1080",
    units_of_measure: "LF",
    description: '24" LINES',
  },
  railroad_x: {
    cost_code: "1090",
    cost_type: "59978",
    account: "59978.1090",
    units_of_measure: "LF",
    description: "RAILROAD - X",
  },
  cross_walks: {
    cost_code: "1100",
    cost_type: "59978",
    account: "59978.1100",
    units_of_measure: "LF",
    description: "CROSSWALKS",
  },
  stop_lines: {
    cost_code: "1100",
    cost_type: "59978",
    account: "59978.1100",
    units_of_measure: "LF",
    description: "STOP LINES",
  },
  speed_hump: {
    cost_code: "1110",
    cost_type: "59978",
    account: "59978.1110",
    units_of_measure: "EA",
    description: "SPEED HUMP MARKING",
  },
  school_message: {
    cost_code: "1120",
    cost_type: "59978",
    account: "59978.1120",
    units_of_measure: "EA",
    description: "SCHOOL MESSAGE",
  },
  bus_message: {
    cost_code: "1130",
    cost_type: "59978",
    account: "59978.1130",
    units_of_measure: "EA",
    description: "BUS MESSAGE",
  },
  message_only: {
    cost_code: "1140",
    cost_type: "59978",
    account: "59978.1140",
    units_of_measure: "EA",
    description: "MESSAGE ONLY",
  },
  stop_message: {
    cost_code: "1150",
    cost_type: "59978",
    account: "59978.1150",
    units_of_measure: "EA",
    description: "STOP MESSAGE",
  },
  left_or_right_arrows: {
    cost_code: "1160",
    cost_type: "59978",
    account: "59978.1160",
    units_of_measure: "EA",
    description: "LEFT & OR RIGHT ARROWS",
  },
  straight_arrows: {
    cost_code: "1170",
    cost_type: "59978",
    account: "59978.1170",
    units_of_measure: "EA",
    description: "STRAIGHT ARROWS",
  },
  combination_arrows: {
    cost_code: "1180",
    cost_type: "59978",
    account: "59978.1180",
    units_of_measure: "EA",
    description: "COMBINATION ARROWS",
  },
  railroad_rr: {
    cost_code: "1190",
    cost_type: "59978",
    account: "59978.1190",
    units_of_measure: "EA",
    description: "RAILROAD - RR",
  },
  bump: {
    cost_code: "1200",
    cost_type: "59978",
    account: "59978.1200",
    units_of_measure: "EA",
    description: "BUMP",
  },
  bicycle_lane_arrow: {
    cost_code: "1210",
    cost_type: "59978",
    account: "59978.1210",
    units_of_measure: "EA",
    description: "BYCYCLE LANE ARROW",
  },
  bicycle_lane_symbol: {
    cost_code: "1220",
    cost_type: "59978",
    account: "59978.1220",
    units_of_measure: "EA",
    description: "BYCYCLE LANE SYMBOL",
  },
  mph_message: {
    cost_code: "1230",
    cost_type: "59978",
    account: "59978.1230",
    units_of_measure: "EA",
    description: "20 MPH MESSAGE",
  },
  ped_message: {
    cost_code: "1240",
    cost_type: "59978",
    account: "59978.1240",
    units_of_measure: "EA",
    description: "PED X-ING MESSAGE",
  },
  sharks_teeth: {
    cost_code: "1120",
    cost_type: "59978",
    account: "59978.1120",
    units_of_measure: "EA",
    description: 'SHARKS TEETH 24"x36"',
  },
  number_of_hours_doing_layout: {
    cost_code: "1800",
    cost_type: "59978",
    account: "59978.1800",
    units_of_measure: "HR",
    description: "LAYOUT",
  },
  water_blasting: {
    cost_code: "1010",
    cost_type: "59978",
    account: "59978.1010",
    units_of_measure: "SF",
    description: "WATER BLASTING FOR SURFACE PREP",
  },
  color_surface: {
    cost_code: "1020",
    cost_type: "59978",
    account: "59978.1020",
    units_of_measure: "SF",
    description: "COLOR SURFACE TREATMENT",
  },

  chevrons: {
    cost_code: "1040",
    cost_type: "59978",
    account: "59978.1040",
    units_of_measure: "LF",
    description: "CHEVRONS",
  },

  epoxy_gravel: {
    cost_code: "1270",
    cost_type: "59978",
    account: "59978.1270",
    units_of_measure: "SF",
    description: "EPOXY GRAVEL",
  },

  custom_message: {
    cost_code: "1250",
    cost_type: "59978",
    account: "59978.1250",
    units_of_measure: "EA",
    description: "CUSTOM MESSAGE",
  },

  bike_green_preform: {
    cost_code: "1240",
    cost_type: "59978",
    account: "59978.1240",
    units_of_measure: "SF",
    description: "BIKE GREEN PREFORM",
  },
};

const getChangedFields = (initialData, data) => {
  const changes = {};
  Object.keys(data).forEach((key) => {
    if (data[key]?.value != initialData[key]?.value) {
      changes[key] =
        parseInt(data[key].value) - parseInt(initialData[key].value);
    }
  });

  return changes;
};

const MetroJobProduction = ({ totals, project }) => {
  const [initialTotals, setInitialTotals] = useState(totals);
  const [data, setData] = useState(totals);
  const [open, setOpen] = useState(false);
  const [changedFields, setChangedFields] = useState({});

  useEffect(() => {
    setChangedFields(getChangedFields(initialTotals, data));
  }, [data]);

  const updateDataValues = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
      },
    }));
  };

  const saveChanges = async () => {
    try {
      const response = await fetch(
        `/admin/metro_jobs/${project.id}/save_changes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document
              .querySelector('meta[name="csrf-token"]')
              .getAttribute("content"),
          },
          body: JSON.stringify({
            changes: changedFields,
          }),
        }
      );

      if (response.ok) {
        const responseBody = await response.json();
        console.log("Saved successfully:", responseBody);

        setInitialTotals(data);

        // Show success message with alertify
        alertify.success(responseBody.message || "Changes saved!");
        // Close the modal
        setOpen(false);
      } else {
        console.error("Failed to save changes");
        alertify.error("Failed to save changes.");
      }
    } catch (error) {
      console.error("Error saving changes:", error);
      alertify.error("An error occurred while saving changes.");
    }
  };

  const saveBtnHandler = () => {
    setOpen(true);
  };

  let disabled = Object.keys(changedFields).length == 0;

  return (
    <>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            p: 4,
            backgroundColor: "white",
            m: "auto",
            mt: 10,
            width: 450,
          }}
        >
          <Typography variant="h6" component="h3" sx={{ fontWeight: "bold" }}>
            Summary of Your Changes
          </Typography>
          <Table>
            <TableBody>
              {Object.keys(changedFields).map((key) => {
                return (
                  <TableRow>
                    <TableCell component="th">
                      {roadArkings[key].description}
                    </TableCell>
                    <TableCell>{changedFields[key]}</TableCell>
                    <TableCell>{roadArkings[key].units_of_measure}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <ButtonGroup>
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                color="info"
                onClick={saveChanges}
              >
                Submit
              </Button>
              <Button
                variant="contained"
                onClick={() => setOpen(false)}
                sx={{ mt: 2 }}
                color="error"
              >
                Close
              </Button>
            </ButtonGroup>
          </Box>
        </Box>
      </Modal>
      <div style={{ padding: "10px 20px", border: "1px solid #e4eaec" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3>
            <span>
              <i className="fa fa-road"></i> Production
            </span>
          </h3>
          <Button color="info" onClick={saveBtnHandler} disabled={disabled}>
            Save Changes
          </Button>
        </div>
        <Table size="small">
          <TableBody>
            {Object.keys(roadArkings).map((key) => {
              return (
                <TableRow key={key}>
                  <TableCell>{roadArkings[key].cost_code}</TableCell>
                  <TableCell>{roadArkings[key].cost_type}</TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#00aeef",
                      width: "255px",
                      color: "#fff",
                    }}
                  >
                    {roadArkings[key].description}
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="number"
                      inputMode={{ step: "1" }}
                      variant="outlined"
                      size="small"
                      value={data[key].value}
                      disabled={data[key].disabled}
                      onChange={(e) => updateDataValues(key, e.target.value)}
                      sx={{ width: 100 }}
                    />
                  </TableCell>
                  <TableCell>{roadArkings[key].units_of_measure}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </>
  );
};

export default MetroJobProduction;
